import { Clickable, Col, Icon, Row, Text } from 'components';
import { startOfMonth } from 'date-fns';
import { getCost, theme } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { filterHistory } from '../lib';

import { RevenueSelector } from './';

const MonthlyTarget = ({ revenueTarget, paymentHistory }) => {
  const [showModal, setShowModal] = useState(false),
    [monthlyTotal, setMonthlyTotal] = useState(null),
    percentage = (monthlyTotal / revenueTarget) * 100,
    { t } = useTranslation();

  useEffect(() => {
    if (!paymentHistory) return;
    const now = new Date();
    const end = startOfMonth(now);

    const total = filterHistory(paymentHistory, [now, end]).reduce((x, y) => {
      const cost = getCost(y.rates, y.currency, y.amount, 'usd');

      return x + (cost.convertedPrice - (y.fee / 100) * cost.convertedPrice) / 100;
    }, 0);
    setMonthlyTotal(total);
  }, [paymentHistory]);

  function handleModal() {
    setShowModal(!showModal);
  }

  function getValueText(val) {
    const roundDigits = val < 1000000 ? 3 : 6;
    const num = Number(val);
    const text = Math.floor(num / Math.pow(10, roundDigits)).toString();

    switch (true) {
      case val < 1000000:
        return `from ${text}K`;

      case val === 1000000:
        return `from ${text}M`;

      case val > 1000000:
        return `from ${text}M+`;

      default:
    }
  }

  return (
    <Col wid="100%">
      <Text h2>{t('dashboard.monthlyTarget')}</Text>

      <Col
        marg="8px 0 0"
        ht="82px"
        noFlex
        between
        wid="calc(100% - 32px)"
        bg="#000"
        pad="12px 16px 16px"
      >
        <Row between center wid="100%">
          <Text h1 col="#fff">
            {monthlyTotal?.toLocaleString(undefined, { style: 'currency', currency: 'USD' })}
          </Text>

          {showModal && <RevenueSelector handleModal={handleModal} revenueTarget={revenueTarget} />}

          <Clickable onClick={() => setShowModal(true)}>
            <Icon col="#fff" type="edit" dimensions={18} />
          </Clickable>
        </Row>

        <Col wid="100%">
          <Row between wid="100%">
            <Text b1 col="#fff">
              {(percentage || 0).toFixed(0)}%
            </Text>

            <Text b1 col="#fff">
              {getValueText(revenueTarget)}
            </Text>
          </Row>

          <Row marg="4px 0 0" wid="100%" ht="8px" bg="#fff" start>
            <Row wid={`${percentage}%`} ht="8px" bg={theme.SECONDARY} />
          </Row>
        </Col>
      </Col>
    </Col>
  );
};

export default MonthlyTarget;
